


















































































import Campaign, { CampaignFilters } from "@/models/campaign";
import CampaignsAPI from "@/services/campaigns";
import { Component, Vue, Watch } from "vue-property-decorator";
import TableActions from "@/components/TableActions.vue";
import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import { Meta, MetaPagination, QueryParams } from "@/models/general";
import { get, set } from "lodash";
import { LayoutModule } from "@/store/layout";
import { CampaignModule } from "@/store/campaign";
import CampaignFilter from "./Components/CampaignFilters.vue";
import FiltersHelper from "@/helpers/filters";
import User from "@/models/user";
import { UserModule } from "@/store/user";
import UsersAPI from "@/services/users";
import { composeDateRange } from "@/helpers/dateHelpers";
import CampaignHelper from "@/helpers/campaign";

@Component({ components: { TableActions } })
export default class MyCampaigns extends Vue {
  campaigns: Campaign[] = [];
  meta: Meta = new Meta();
  users: User[] = [];
  pagination = {};
  loading = true;
  composeDate = composeDateRange;

  headers = [
    {
      text: this.$t("campaigns.model.name"),
      sortable: false,
      value: "name",
    },
    {
      text: this.$t("campaigns.model.ref"),
      sortable: false,
      value: "ref",
    },
    {
      text: this.$t("campaigns.model.seller"),
      sortable: false,
      value: "userId",
    },
    {
      text: this.$t("campaigns.model.company"),
      sortable: false,
      value: "company",
    },
    {
      text: `${this.$t("campaigns.model.start")}/${this.$t(
        "campaigns.model.end"
      )}`,
      sortable: false,
      value: "start",
      width: "200px",
    },
    {
      text: this.$t("campaigns.model.status"),
      sortable: false,
      value: "status",
    },

    {
      text: "",
      sortable: false,
      value: "id",
    },
  ];

  get getFilter(): boolean {
    let filterIsEnabled = false;
    Object.keys(CampaignModule.getCurrentFilter).forEach((key) => {
      if (get(CampaignModule.getCurrentFilter, key, []).length > 0) {
        filterIsEnabled = true;
      }
    });

    return filterIsEnabled;
  }

  get isAdmin(): boolean {
    return UserModule.isAdmin;
  }

  async created(): Promise<void> {
    this.setTablePagination();
    await this.getUsers();
    await this.getCampaigns();
  }

  composeStatusLabel(s: string): string {
    const status = CAMPAIGN_STATUS_LIST.find((i) => {
      return i.key === s;
    });

    return status ? this.$t(status.label).toString() : "";
  }

  async getUsers(): Promise<void> {
    try {
      const params: QueryParams = {
        page: {
          size: -1,
        },
      };

      const r = await UsersAPI.getUsers(params);
      this.users = r.data;
    } catch (e) {
      console.log(e);
    }
  }

  async getCampaigns(): Promise<void> {
    this.loading = true;
    const filter: CampaignFilters = {
      ...CampaignModule.getCurrentFilter,
      user_id: [UserModule.getCurrentUser.id],
    };

    try {
      const r = await CampaignsAPI.list(
        this.meta.pagination.current,
        this.meta.pagination.size,
        FiltersHelper.buildRequestFilters(filter)
      );

      this.campaigns = r.data;

      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  }

  editCampaign(campaign: Campaign): void {
    this.$router.push({
      name: "edit-campaign",
      params: { id: String(campaign.id) },
    });
  }

  // @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");
    CampaignModule.setPagination(this.meta.pagination);

    this.getCampaigns();
  }

  @Watch("getFilter", { deep: true })
  applyFilter(): void {
    console.log("apply filter");

    CampaignModule.setPagination(new MetaPagination());
    this.setTablePagination();
    this.getCampaigns();
  }

  showFilters(): void {
    LayoutModule.setRightDrawerComponent(CampaignFilter);
    LayoutModule.setRightDrawerComponentProps({ user: UserModule.currentUser });
    LayoutModule.showRightDrawer();
  }

  setTablePagination(): void {
    set(this.pagination, "page", CampaignModule.getPagination.current);
    set(this.pagination, "itemsPerPage", CampaignModule.getPagination.size);
  }

  getSellerName(id: string): string {
    const u = this.users.find((e) => e.id === id);
    const name = u ? `${u.name} ${u.familyName}` : "";

    return name;
  }

  campaignStatusColor(status: string): string {
    return CampaignHelper.getColorClass(status);
  }
}
